import { render, staticRenderFns } from "./mailrecord.vue?vue&type=template&id=4bdea240&"
import script from "./mailrecord.vue?vue&type=script&lang=js&"
export * from "./mailrecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports